import React from 'react';
import { X, ChevronLeft, ChevronRight, ExternalLink, Github } from 'lucide-react';

const ProjectModal = ({ 
  selectedProject, 
  setSelectedProject, 
  currentImageIndex, 
  setCurrentImageIndex 
}) => {
  if (!selectedProject) return null;

  const nextImage = () => {
    setCurrentImageIndex((prev) =>
      prev === selectedProject.images.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? selectedProject.images.length - 1 : prev - 1
    );
  };

  return (
    <div className="modal-overlay" onClick={() => setSelectedProject(null)}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button
          className="modal-close"
          onClick={() => setSelectedProject(null)}
        >
          <X size={24} />
        </button>

        <div className="modal-header">
          <h3>{selectedProject.title}</h3>
        </div>

        <div className="image-carousel">
          <button className="carousel-btn prev" onClick={prevImage}>
            <ChevronLeft size={24} />
          </button>

          <div className="carousel-image">
            <a
              href={selectedProject.images[currentImageIndex]}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={selectedProject.images[currentImageIndex]}
                alt={selectedProject.title}
              />
            </a>
          </div>

          <button className="carousel-btn next" onClick={nextImage}>
            <ChevronRight size={24} />
          </button>

          <div className="carousel-dots">
            {selectedProject.images.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => setCurrentImageIndex(index)}
              ></button>
            ))}
          </div>
        </div>

        <div className="modal-body">
          <p>{selectedProject.description}</p>
          <div>
            <div className="features-title">Overview</div>
            <ul className='project-checklist'>
              {selectedProject.checklist.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <div>
            <div className="features-title">Features</div>
            <ul className="project-features">
              {selectedProject.features.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="project-links">
            {selectedProject.liveLink && (
              <a href={selectedProject.liveLink} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                <ExternalLink size={16} />
                Live Demo
                </a>
              )}
              <a href={selectedProject.githubLink} target="_blank" rel="noopener noreferrer" className="btn btn-outline">
                <Github size={16} />
                View Code
              </a>
            </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;
